import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { useWeb3React } from "@web3-react/core";
import { projectContractsConfig } from "../../contracts/projectContractsConfig";

const BuyAgain1 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const project = localStorage.getItem("project");

  const buyAgain1 = useCallback(
    async (round, min, api, indexes, nodeMinerVersion) => {
      try {
        const config = projectContractsConfig.find((p) => p.id === project);

        if (!config) {
          throw new Error(`Project configuration not found for: ${project}`);
        }

        // Get the appropriate claim contract based on version
        let contractConfig;
        if (nodeMinerVersion && (project === "RAIN" || project === "ASTRANOVA")) {
          const versionKey = `claimV${nodeMinerVersion}`;
          contractConfig = config.contracts[versionKey];

          if (!contractConfig) {
            throw new Error(`Version ${nodeMinerVersion} not found for project: ${project}`);
          }
        } else {
          contractConfig = config.contracts.claim;
        }

        const contract = contractConfig.contract(contractConfig.address, web3);

        // Handle GEMS special case (different parameter order)
        if (project === "GEMS") {
          const details = await contract.methods
            .purchaseWithClaim(
              api?.round,
              api?.deadline,
              api?.factors,
              api?.prices,
              api?.tokens,
              api?.amounts,
              min,
              api.v,
              api.r,
              api.s
            )
            .send({
              from: account,
            });
          return details;
        }

        // Standard purchase with claim for most projects
        const details = await contract.methods
          .purchaseWithClaim(
            api?.deadline?.toString(),
            api?.amounts,
            indexes,
            min,
            api?.prices,
            api?.tokens,
            api?.round?.toString(),
            api?.factor,
            api.v,
            api.r,
            api.s
          )
          .send({
            from: account,
          });

        return details;
      } catch (error) {
        console.error(`Error in buyAgain1 for ${project}:`, error);
        throw error;
      }
    },
    [project, account, web3]
  );

  return { buyAgain1 };
};

export default BuyAgain1;
// import { useCallback } from "react";
// import useWeb3 from "../useWeb3";
// import environment from "../../utils/Environment";
// import { useWeb3React } from "@web3-react/core";
// import {
//   getClaimNewLatest,
//   getGemsClaimsContract,
//   getIncentivClaimsContract,
//   getLEIAClaimsContract,
//   getOlympusClaimsContract,
//   getNFAClaimsContract,
//   getAstroNovaClaimsContract,
//   getAstroNovaClaimsV2Contract,
//   getRainClaimsContract,
//   getRainClaimsV2Contract,
//   getRainClaimsV3Contract,
//   getLuckifyClaimsContract,
//   getScrexClaimsContract
// } from "../../utils/contractHelpers";

// const BuyAgain1 = () => {
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = environment.claimNewLatest;
//   const contract = getClaimNewLatest(tokenAddress, web3);
//   const gemsAddress = environment.GEMSClaim;
//   const IncentivAddress = environment.IncentivClaim;
//   const LEIAAddress = environment.LEIAClaim;
//   const OlympusAddress = environment.OlympusClaim;
//   const NFAAddress = environment.NFAClaim;
//   const AstroNovaAddress = environment.AstroNovaClaim;
//   const AstroNovaAddressV2 = environment.AstroNovaClaimV2;

//   const RainAddress = environment.RainClaim;
//   const RainAddressV2 = environment.RainClaimV2;
//   const RainAddressV3 = environment.RainClaimV3;

//   const gemsClaimsContract = getGemsClaimsContract(gemsAddress, web3);
//   const incentivClaimsContract = getIncentivClaimsContract(
//     IncentivAddress,
//     web3
//   );

//   const LEIAClaimsContract = getLEIAClaimsContract(LEIAAddress, web3);
//   const LUCKIFYClaimsContract = getLuckifyClaimsContract( environment.LUCKIFYClaim, web3);
//   const SCREXClaimsContract = getScrexClaimsContract(environment.SCREXClaim, web3);
//   const CHAINERSClaimsContract = getScrexClaimsContract(environment.CHAINERSClaim, web3);
//   const OlympusClaimsContract = getOlympusClaimsContract(OlympusAddress, web3);
//   const NFAClaimsContract = getNFAClaimsContract(NFAAddress, web3);
//   const AstroNovaClaimsContract = getAstroNovaClaimsContract(
//     AstroNovaAddress,
//     web3
//   );

//   const AstroNovaClaimsContractV2 = getAstroNovaClaimsV2Contract(
//     AstroNovaAddressV2,
//     web3
//   );

//   const RainClaimsContract = getRainClaimsContract(RainAddress, web3);
//   const RainClaimsContractV2 = getRainClaimsV2Contract(RainAddressV2, web3);
//   const RainClaimsContractV3 = getRainClaimsV3Contract(RainAddressV3, web3);

//   const project = localStorage.getItem("project");

//   const buyAgain1 = useCallback(
//     async (round, min, api, indexes, nodeMinerVersion) => {
//       if (project == "INCENTIV") {
//         try {
//           // console.log(
//             "deadline: ",
//             api?.deadline,
//             "\n amounts: ",
//             api?.amounts,
//             "\n indexes: ",
//             indexes,
//             "\n minimum amounts: ",
//             min,
//             "prices: ",
//             api?.prices,
//             "\n tokens:",
//             api?.tokens,
//             "\n round: ",
//             "5",
//             "\nfactors: ",
//             api?.factor,
//             "\n v: ",
//             api.v,
//             "\n r: ",
//             api.r,
//             "\ns: ",
//             api.s
//           );
//           let gasPrice = await web3.eth.getGasPrice();
//           gasPrice = parseInt(gasPrice);
//           const gas = await incentivClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .estimateGas({
//               from: account,
//             });

//           const details = await incentivClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               gas: gas,
//               gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "LUCKIFY") {
//         try {
          
//           // let gasPrice = await web3.eth.getGasPrice();
//           // gasPrice = parseInt(gasPrice);
//           // const gas = await LEIAClaimsContract.methods
//           //   .purchaseWithClaim(
//           //     api?.deadline?.toString(),
//           //     api?.amounts,
//           //     indexes,
//           //     min,
//           //     api?.prices,
//           //     api?.tokens,
//           //     api?.round?.toString(),
//           //     api?.factor,
//           //     api.v,
//           //     api.r,
//           //     api.s
//           //   )
//           //   .estimateGas({
//           //     from: account,
//           //   });
//           const details = await LUCKIFYClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               // gas: gas,
//               // gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } 
//       else if (project == "SCREX") {
//         try {
          
//           // let gasPrice = await web3.eth.getGasPrice();
//           // gasPrice = parseInt(gasPrice);
//           // const gas = await LEIAClaimsContract.methods
//           //   .purchaseWithClaim(
//           //     api?.deadline?.toString(),
//           //     api?.amounts,
//           //     indexes,
//           //     min,
//           //     api?.prices,
//           //     api?.tokens,
//           //     api?.round?.toString(),
//           //     api?.factor,
//           //     api.v,
//           //     api.r,
//           //     api.s
//           //   )
//           //   .estimateGas({
//           //     from: account,
//           //   });
//           const details = await SCREXClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               // gas: gas,
//               // gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "CHAINERS") {
//         try {
          
//           // let gasPrice = await web3.eth.getGasPrice();
//           // gasPrice = parseInt(gasPrice);
//           // const gas = await LEIAClaimsContract.methods
//           //   .purchaseWithClaim(
//           //     api?.deadline?.toString(),
//           //     api?.amounts,
//           //     indexes,
//           //     min,
//           //     api?.prices,
//           //     api?.tokens,
//           //     api?.round?.toString(),
//           //     api?.factor,
//           //     api.v,
//           //     api.r,
//           //     api.s
//           //   )
//           //   .estimateGas({
//           //     from: account,
//           //   });
//           const details = await CHAINERSClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               // gas: gas,
//               // gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "NFA") {
//         try {
          
//           let gasPrice = await web3.eth.getGasPrice();
//           gasPrice = parseInt(gasPrice);
//           const gas = await NFAClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .estimateGas({
//               from: account,
//             });
//           const details = await NFAClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               gas: gas,
//               gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "ASTRANOVA") {
//         if (nodeMinerVersion == 1) {
//           try {
//             // console.log(
//               "deadline: ",
//               api?.deadline,
//               "\n amounts: ",
//               api?.amounts,
//               "\n indexes: ",
//               indexes,
//               "\n minimum amounts: ",
//               min,
//               "prices: ",
//               api?.prices,
//               "\n tokens:",
//               api?.tokens,
//               "\n round: ",
//               api?.round?.toString(),
//               "\nfactors: ",
//               api?.factor,
//               "\n v: ",
//               api.v,
//               "\n r: ",
//               api.r,
//               "\ns: ",
//               api.s
//             );
//             let gasPrice = await web3.eth.getGasPrice();
//             gasPrice = parseInt(gasPrice);
//             const gas = await AstroNovaClaimsContract.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .estimateGas({
//                 from: account,
//               });
//             const details = await AstroNovaClaimsContract.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .send({
//                 from: account,
//                 gas: gas,
//                 gasPrice,
//               });
//             return details;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             // console.log(
//               "deadline: ",
//               api?.deadline,
//               "\n amounts: ",
//               api?.amounts,
//               "\n indexes: ",
//               indexes,
//               "\n minimum amounts: ",
//               min,
//               "prices: ",
//               api?.prices,
//               "\n tokens:",
//               api?.tokens,
//               "\n round: ",
//               api?.round?.toString(),
//               "\nfactors: ",
//               api?.factor,
//               "\n v: ",
//               api.v,
//               "\n r: ",
//               api.r,
//               "\ns: ",
//               api.s
//             );
//             let gasPrice = await web3.eth.getGasPrice();
//             gasPrice = parseInt(gasPrice);
//             const gas = await AstroNovaClaimsContractV2.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .estimateGas({
//                 from: account,
//               });
//             const details = await AstroNovaClaimsContractV2.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .send({
//                 from: account,
//                 gas: gas,
//                 gasPrice,
//               });
//             return details;
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "RAIN") {
//         if (nodeMinerVersion == 1) {
//           try {
//             // console.log(
//               "deadline: ",
//               api?.deadline,
//               "\n amounts: ",
//               api?.amounts,
//               "\n indexes: ",
//               indexes,
//               "\n minimum amounts: ",
//               min,
//               "prices: ",
//               api?.prices,
//               "\n tokens:",
//               api?.tokens,
//               "\n round: ",
//               api?.round?.toString(),
//               "\nfactors: ",
//               api?.factor,
//               "\n v: ",
//               api.v,
//               "\n r: ",
//               api.r,
//               "\ns: ",
//               api.s
//             );
//             let gasPrice = await web3.eth.getGasPrice();
//             gasPrice = parseInt(gasPrice);
//             const gas = await RainClaimsContract.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .estimateGas({
//                 from: account,
//               });
//             const details = await RainClaimsContract.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .send({
//                 from: account,
//                 gas: gas,
//                 gasPrice,
//               });
//             return details;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 2) {
//           try {
//             // console.log(
//               "deadline: ",
//               api?.deadline,
//               "\n amounts: ",
//               api?.amounts,
//               "\n indexes: ",
//               indexes,
//               "\n minimum amounts: ",
//               min,
//               "prices: ",
//               api?.prices,
//               "\n tokens:",
//               api?.tokens,
//               "\n round: ",
//               api?.round?.toString(),
//               "\nfactors: ",
//               api?.factor,
//               "\n v: ",
//               api.v,
//               "\n r: ",
//               api.r,
//               "\ns: ",
//               api.s
//             );
//             let gasPrice = await web3.eth.getGasPrice();
//             gasPrice = parseInt(gasPrice);
//             const gas = await RainClaimsContractV2.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .estimateGas({
//                 from: account,
//               });
//             const details = await RainClaimsContractV2.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .send({
//                 from: account,
//                 gas: gas,
//                 gasPrice,
//               });
//             return details;
//           } catch (error) {
//             throw error;
//           }
//         } else if (nodeMinerVersion == 3) {
//           try {
//             // console.log(
//               "deadline: ",
//               api?.deadline,
//               "\n amounts: ",
//               api?.amounts,
//               "\n indexes: ",
//               indexes,
//               "\n minimum amounts: ",
//               min,
//               "prices: ",
//               api?.prices,
//               "\n tokens:",
//               api?.tokens,
//               "\n round: ",
//               api?.round?.toString(),
//               "\nfactors: ",
//               api?.factor,
//               "\n v: ",
//               api.v,
//               "\n r: ",
//               api.r,
//               "\ns: ",
//               api.s
//             );
//             let gasPrice = await web3.eth.getGasPrice();
//             gasPrice = parseInt(gasPrice);
//             const gas = await RainClaimsContractV3.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .estimateGas({
//                 from: account,
//               });
//             const details = await RainClaimsContractV3.methods
//               .purchaseWithClaim(
//                 api?.deadline?.toString(),
//                 api?.amounts,
//                 indexes,
//                 min,
//                 api?.prices,
//                 api?.tokens,
//                 api?.round?.toString(),
//                 api?.factor,
//                 api.v,
//                 api.r,
//                 api.s
//               )
//               .send({
//                 from: account,
//                 gas: gas,
//                 gasPrice,
//               });
//             return details;
//           } catch (error) {
//             throw error;
//           }
//         }
//       } else if (project == "LEIA") {
//         try {
          
//           // let gasPrice = await web3.eth.getGasPrice();
//           // gasPrice = parseInt(gasPrice);
//           // const gas = await LEIAClaimsContract.methods
//           //   .purchaseWithClaim(
//           //     api?.deadline?.toString(),
//           //     api?.amounts,
//           //     indexes,
//           //     min,
//           //     api?.prices,
//           //     api?.tokens,
//           //     api?.round?.toString(),
//           //     api?.factor,
//           //     api.v,
//           //     api.r,
//           //     api.s
//           //   )
//           //   .estimateGas({
//           //     from: account,
//           //   });
//           const details = await LEIAClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               // gas: gas,
//               // gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "OLYMPUS") {
//         try {
          
//           let gasPrice = await web3.eth.getGasPrice();
//           gasPrice = parseInt(gasPrice);
//           const gas = await OlympusClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .estimateGas({
//               from: account,
//             });
//           const details = await OlympusClaimsContract.methods
//             .purchaseWithClaim(
//               api?.deadline?.toString(),
//               api?.amounts,
//               indexes,
//               min,
//               api?.prices,
//               api?.tokens,
//               api?.round?.toString(),
//               api?.factor,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               gas: gas,
//               gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else if (project == "GEMS") {
//         try {
//           // let gasPrice = await web3.eth.getGasPrice();
//           // gasPrice = parseInt(gasPrice) + 3000000000;
//           // const gas = await gemsClaimsContract.methods
//           //   .purchaseWithClaim(
//           //     api?.round,
//           //     api?.deadline,
//           //     api?.factors,
//           //     api?.prices,
//           //     api?.tokens,
//           //     api?.amounts,
//           //     min,
//           //     api.v,
//           //     api.r,
//           //     api.s
//           //   )
//           //   .estimateGas({
//           //     from: account,
//           //   });
//           const details = await gemsClaimsContract.methods
//             .purchaseWithClaim(
//               api?.round,
//               api?.deadline,
//               api?.factors,
//               api?.prices,
//               api?.tokens,
//               api?.amounts,
//               min,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               // gas: gas,
//               // gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       } else {
//         try {
//           let gasPrice = await web3.eth.getGasPrice();
//           gasPrice = parseInt(gasPrice) + 3000000000;
//           const gas = await contract.methods
//             .purchaseWithClaim(
//               api?.round,
//               api?.deadline,
//               api?.factors,
//               api?.prices,
//               api?.tokens,
//               api?.amounts,
//               min,
//               api.v,
//               api.r,
//               api.s
//             )
//             .estimateGas({
//               from: account,
//             });
//           const details = await contract.methods
//             .purchaseWithClaim(
//               api?.round,
//               api?.deadline,
//               api?.factors,
//               api?.prices,
//               api?.tokens,
//               api?.amounts,
//               min,
//               api.v,
//               api.r,
//               api.s
//             )
//             .send({
//               from: account,
//               gas: gas,
//               gasPrice,
//             });
//           return details;
//         } catch (error) {
//           throw error;
//         }
//       }
//     },
//     [contract, account, web3]
//   );
//   return { buyAgain1: buyAgain1 };
// };
// export default BuyAgain1;
